import React, { useMemo } from "react";
import TableComponent, { IRow } from "components/tableComponent";
import { THeadCell } from "utils/types";
import { LocalizeText } from "components/localizer";
import Banner from "components/banner";
import { useNavigate } from "react-router-dom";
import { usePaginationStore } from "utils/usePaginationStore";
import SearchFilterField from "components/searchFilterField";
import CommunityFilterInput from "components/searchFilterComponents/communityFilter";

const mailTemplateTableHeader: THeadCell[] = [
    { id: "id", label: <LocalizeText tag="id" /> },
    { id: "name", sortId: "name", label: <LocalizeText tag="name" /> },
    { id: "arena", sortId: "community__title", label: <LocalizeText tag="arena" /> },
];

const MailTemplateView: React.FC = () => {
    const navigate = useNavigate();
    const pagination = usePaginationStore("mail-templates", undefined, {
        mail_template_type: "community_specific",
        page_size: 20,
        default_page_size: 20,
    });

    const rows = useMemo((): IRow[] => {
        return pagination.results.map((template) => {
            return {
                onClick: () => navigate("/staff-mail-templates/" + template.id),
                data: [template.id, template.name, template.community_name],
            };
        });
    }, [pagination.results]);

    return (
        <div className="contentWrapper">
            <Banner
                title="bannerMailTemplatesTitle"
                subTitle="bannerMailTemplates"
                imageStyle={{ objectPosition: "60% 40%" }}
                image={`${process.env.PUBLIC_URL}/assets/images/arenaStaff/mailTemplates.jpg`}
            />
            <SearchFilterField
                pagination={pagination}
                label={<LocalizeText tag="searchMailTemplate" />}
                filterFields={<CommunityFilterInput pagination={pagination} />}
            />
            <TableComponent
                headCells={mailTemplateTableHeader}
                pagination={pagination}
                isLoading={pagination.query.isFetching}
                skeletonVariant="options"
                rows={rows}
            />
        </div>
    );
};

export default MailTemplateView;
